<template>
  <a-modal
  :visible="hidden"
  @ok="ok" 
  @cancel="cancel"
  :bodyStyle="{padding:'10px'}"
  title="复制配方"
  :maskClosable="false"
  width="800px"
  okText="确定"
  cancelText="取消">
    <a-spin :spinning="copyLoading" tip="配方复制中">
      <a-form-model
        size="small"
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :validateOnRuleChange="true"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="复制源" prop="formulaCode">
          <a-input :disabled="true" size="small" style="width:100%"  placeholder="复制源" v-model="form.formulaCode" />
        </a-form-model-item>
        <a-form-model-item label="配方名称" prop="formulaName">
          <a-input size="small" style="width:100%" placeholder="配方名称" v-model.trim="form.formulaName" />
        </a-form-model-item>
        <a-form-model-item label="工厂名称" prop="factoryId">
          <!-- <a-input size="small" style="width:100%" placeholder="工厂名称" v-model.trim="form.factoryName" /> -->
          <a-select v-model='form.factoryId'>
            <a-select-option v-for="el in factoryArr" :key="el.factoryId" :value="el.factoryId">{{el.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-textarea :max-length="150"  size="small" style="width:100%"  placeholder="输入备注" v-model="form.remark" />
        </a-form-model-item>
      </a-form-model>
  </a-spin>
</a-modal>
</template>

<script>
import { nhfMixins } from '../../untils'
export default {
  mixins:[nhfMixins],
  props:['hidden','formulaId'],
  data(){
    return {
      form:{},
      copyLoading:false,
      rules: {
        // formulaCode: [{ required: true,validator: this.validatorCode,  message: '复制源', trigger: 'change' }],
        formulaName: [{ required: true, message: '输入配方名称', trigger: 'change' }],
        factoryId: [{ required: true, message: '请选择工厂', trigger: 'change' }],
      },
      factoryArr: []
    }
  },
  watch:{
    async hidden(val){
      if(this.formulaId && val){
        await this.fetchPost({
          actions:this.copyFormula,
          name:'form',
          data:{ formulaId:this.formulaId },
          showMessage:false,
        })
        this.form.name = ''
      }
    }
  },
  mounted(){
    this.getFactoryList()
  },
  methods:{
    async getFactoryList(){
      const res = await this.fetchGet({actions:this.factoryList,data:{current: 1,size: 10000}})
      if(res.data) this.factoryArr = res.data.records || []
    },
    async validatorCode(rule,formulaCode,callback){
      let pattern =/^[A-Za-z0-9]+$/
      if(formulaCode.length){
        if(!pattern.test(formulaCode)){
          callback(new Error('配方代码只能由数字和字母组成'))
          return
        }
        const result = await this.fetchPost({
          actions:this.checkFormulaCodeIsUnique,
          showMessage:false,
          data:{
            formulaCode
          }
        })
        result ? callback() : callback(new Error('配方代码重复'))
      }else{
       callback(new Error('请输入配方代码')) 
      }
    },
    cancel(){
      this.$emit('cancel')
    },
    ok(){
      this.$refs.ruleForm.validate( valid => {
        if (valid) {
          let form  = this.form
          // this.copyAction(form)
          this.$emit('ok',form)
        }
      })
    },
   
  }
}
</script>
